import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DateTimePicker from "react-datetime-picker";
import CalendarIcon from "../../../Resources/svg/date-picker.svg";
import { weftType as WeftTypeList } from '../../../Utils/constants';
import { modalAside } from "../../../Store/simulate/actions";

import { handleState, formatNumber } from "../../../Utils/utils";
import { validateRangeDate, calcDaysPassed } from '../../../Utils/validators'
import { handleTransformDataSimulations, handleTransformDataAprovations } from "../../../Utils/simulaciones/simulaciones";
import { useForm } from "react-hook-form";
import Terciary from "./Terciary";
import ErrorCustom from "../../../Components/errorCustom";
import Button from "../../../Components/FormElements/Button";
import CardAprobar from "../../../Components/FormElements/CardAprobar";
import FormTitle from "../../../Components/FormElements/FormTitle";
import { API } from "aws-amplify";
import Loading from "../../../Components/loading";
import moment from "moment";
import IconClose from "../../../Resources/svg/Icons/IconClose";
import IconHolder from "../../../Resources/svg/Icons/IconHolder";
import InputNumber from "../../../Components/inputNumber";
import { validateCesionComision, validateTirObjetive } from "../../../Utils/validatorRg";
import { getAdvisers } from "../../../Store/adviser/actions";
const ModalSide = ({
  modalData = {},
  ri = true,
  loading,
  title,
  subtitle = "",
  stateTitle,
  setStateEmision,
  weftType,
  handleSucessImprovements
}: any) => {

  const { handleSubmit, register, setValue, errors, reset, watch, formState, clearError } = useForm({ mode: "onChange" });
  const dispatch = useDispatch();
  const dataStore = useSelector((state: any) => state.adviser.listAdvisers);
  const [ availableAssesorList, setAvailableAssesorList ] = useState([]); 
  let cardCoti: any = [];
  const emision = modalData.datosEmision;
  const datoRI = emision ? emision.numRelIng : "";
  const inputEl: any = useRef(null);
  const [isOpen, setIsOpen] = useState<any>(false);
  const [ loadingState, setLoadingState ] = useState(false);
  const [ simulationData, setSimulationData ] = useState<any>()
  const [ selectedAdviser, setSelectedAdviser ] = useState<any>()
  const [selectDate, setSelectDate] = useState<any>();
  const { adviserSelected } = watch();
  const [errorDate, setErrorDate] = useState<any>();
  const [ formTouched, setFormTouched ] = useState(false)
  const channel = useSelector((state: any) => state.login.channel);
  const validateChannel = ['admin'];

  switch(weftType){
    case WeftTypeList.aprovations:
      cardCoti = handleTransformDataAprovations(modalData)
      break;
    case WeftTypeList.quotes:
      cardCoti = handleTransformDataAprovations(modalData)
      break;
    case WeftTypeList.simulations:
      cardCoti = handleTransformDataSimulations(modalData)
      break;
  }


  useEffect(() => {
    const selectedAdviserResult = dataStore.find((el: any) => el.email == adviserSelected);
    setSelectedAdviser(selectedAdviserResult)
  }, [adviserSelected])

  useEffect(() => {
    if (dataStore.length === 0) {
          const fetchData = async function () {
            getAdvisers(dispatch);
          };
          fetchData();
        }
        if( dataStore.length > 0 && validateChannel.includes(channel) && modalData.asesor ){
    
          const availableAssesorList = dataStore.filter((el: any) => el.email !== modalData.asesor.email);
          setAvailableAssesorList(availableAssesorList)
        
      }

      if(modalData.datosSimulacion && modalData.datosSimulacion.vencimiento){
        const today = new Date(modalData.datosSimulacion.vencimiento);
        setSelectDate(today)
      }
  }, [dataStore, modalData])

  const modalAsideState = useSelector(
    (state: any) => state.simulate.policy.modalAside
  );

  const handleOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleClose = () => {

  setSimulationData(null)
  setSelectedAdviser(null)
  setSelectDate(null)
  setErrorDate(null)
  setFormTouched(false)
    // document.querySelector(".modal-aside__inner").scrollTop = 0;
    const modalInner = document.querySelector(".modal-aside__inner");
    if (modalInner) {
      modalInner.scrollTop = 0;
    }
    setIsOpen(false);
    dispatch(modalAside(false));
    document.body.style.overflow = "auto";
    reset();
    setSimulationData(null)
  };

  const handleSwitch = () => {
    setStateEmision(true);
    handleClose();
  };

  useEffect(() => {
    if (modalAsideState) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [modalAsideState]);

  const findNameOfAssesor = (emailAssesor: any) => {
    const assesor =  dataStore.find((el : any) => el.email ===  emailAssesor);
    return assesor.name + ' ' + assesor.lastName
  }

  const hideInput =
    modalData.estado === "rechazada" || modalData.estado === "vencida"
      ? "d-none"
      : "d-show";


  const improveSimulation = async (values: any) => {
    setFormTouched(true)
    setLoadingState(true)
    const { idSimulacion } = modalData;  
    const request = {
      body: {
        datosParticulares: [
          {
            nombre: 'porcentaje_cesion_comision',
            valor: Number(values.cesion_comision)
          },
          
          {
            nombre: 'tir_objetivo',
            valor: Number(values.tir_objetivo)
          }
        ],
        idSimulacion,
        action: 'getUpgrade'
      },
      headers: {},
    }
    try {
      let response;
      response = await API.post("api-rentas", "/cotizacion", request);
      if (response) {
        setSimulationData(response)
        setLoadingState(false)
      }
    } catch (e) {

      console.log("e", e);
    }
  };

  const updateAdviserAndDate = async () => {
    const { idSimulacion } = modalData;  
    const request = {
      body: {
        
          "adviserEmail": selectedAdviser && selectedAdviser.email ? selectedAdviser.email : modalData.asesor.email ,
          "adviserFullName": selectedAdviser && selectedAdviser.name ? selectedAdviser.name + ' ' + selectedAdviser.lastname : findNameOfAssesor(modalData.asesor.email),
          "idSimulacion": idSimulacion,
          "vencimiento": selectDate ? moment(selectDate).format("YYYY/MM/DD") : moment(modalData.datosSimulacion.vencimiento).format("YYYY/MM/DD")
        
      },
      headers: {},
    }
      let response;
     return response = await API.post("api-rentas", "/update-simulation-adviser", request);
  }
  const sendSimulation = async () => {
    const request = {
      body: {
        ...simulationData,
        action: 'setUpgrade'
      },
      headers: {},
    }
      let response;
      return response = await API.post("api-rentas", "/cotizacion", request);

  }

  const executeApis = async () => {
    let respondSucess = false;
    setLoadingState(true)
    try {
      if( selectedAdviser || selectDate){
        const adviserRespond = await updateAdviserAndDate();
        if(adviserRespond.message){
          respondSucess = true;
        }
      }
      if(simulationData){
        const simulationRespond = await sendSimulation();
        if(simulationRespond.message){
          respondSucess = true; 
        }
      }

      if(respondSucess){
        handleClose()
        handleSucessImprovements()
        setLoadingState(false)
      }
    } catch {
      console.log('error')
    }

  }


  const handleDateChange = (initDate: any, endDate: any) => {
    
      const dateCalcWithCurrentDate = calcDaysPassed(initDate)
      const dateCalc = validateRangeDate(initDate, endDate)

      if ( dateCalcWithCurrentDate < 1 ) {
        setErrorDate( `Seleccione una fecha posterior a la fecha de hoy`);
        setSelectDate(initDate)
      }
      else if(dateCalc >= 46){
        setErrorDate( `La fecha no debe ser mayor a 45 días de la fecha de creación`);
        setSelectDate(initDate)
      }
      else {
        setErrorDate(null)
        setSelectDate(initDate)
      }
      
    };

  return (
    <>
    { isOpen && <div className={"modal-aside is-open"}>
      <div className={"modal-aside__box"}>
        <div className="modal-aside__close" onClick={handleClose}>
          <span>Cerrar</span>
          <IconClose />
        </div>
        <div className="modal-aside__body">
          <div className="modal-aside__inner">
            <div className="modal-aside__gradient"></div>
            <FormTitle
              title={`${title} ${stateTitle ? handleState(modalData.estado) : ""}`}
            />
            {/* {subtitle !== "" && <div className="subtitle-form">{subtitle}</div>} */}
            {/* {data.estado === "porFirmar" && ( */}
            <div className="subtitle-form">{subtitle}</div>
            {modalData.estado === "porFirmar" && (
              <Terciary handleSwitch={handleSwitch} />
            )}
            {cardCoti.map((coti: any) => (
              <CardAprobar
                key={coti.title}
                loading={loading}
                data={coti}
                codigo={modalData.producto.codigo}
              />
            ))}
            {modalData.estado !== "porFirmar" && ri && (
              <div ref={inputEl} className={hideInput}>
                <div className="clientForm__control input-field is-fill">
                  <input
                    id="recaudo2"
                    type="number"
                    name="recaudo2"
                    className="disabled"
                    value={datoRI}
                    disabled={true}
                    defaultValue={datoRI}
                  />
                  <label htmlFor="recaudo">Relación de Ingreso (RI)</label>
                </div>
              </div>
            )}

            {  modalData.producto && weftType === WeftTypeList.simulations && channel === 'admin' && modalData.producto.codigo === 'RG' &&  (
              <div>
             
                <form onSubmit={handleSubmit(improveSimulation)} className="clientForm">

                <div className={"card-verify verify-approved " + `${""}`}>
                  <div className="card-verify__header">
                    <IconHolder />
                    <div className="card-verify__title">DATOS DE PENSIÓN:</div>
                  </div>
                  <p className="card-verify__subtitle">Datos Iniciales</p>
                  <div className="card-verify__body">
                      <div className="card-verify__quote">
                        Pensión: 
                      </div>
                      <div className={`card-verify__data`}>
                      {  modalData.datosSimulacion  && modalData.datosSimulacion.initialValues && modalData.datosSimulacion.initialValues.pension ? modalData.datosSimulacion.moneda.simbolo + formatNumber.new(modalData.datosSimulacion.initialValues.pension) : modalData.datosSimulacion.moneda.simbolo + formatNumber.new(modalData.datosSimulacion.pension) }
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        Tasa de venta: 
                      </div>
                      <div className={`card-verify__data`}>
                      { modalData.datosSimulacion && modalData.datosSimulacion.initialValues && modalData.datosSimulacion.initialValues.tasa ? formatNumber.new(modalData.datosSimulacion.initialValues.tasa) : formatNumber.new(modalData.datosSimulacion.tasa) }%
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        TIR: 
                      </div>
                      <div className={`card-verify__data`}>
                      { modalData.datosSimulacion && modalData.datosSimulacion.initialValues && modalData.datosSimulacion.initialValues.tir_actual ? formatNumber.new(modalData.datosSimulacion.initialValues.tir_actual) : formatNumber.new(modalData.datosSimulacion.tir_actual) }%
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        Cesion comisión actual: 
                      </div>
                      <div className={`card-verify__data`}>
                      { modalData.datosSimulacion && modalData.datosSimulacion.initialValues && modalData.datosSimulacion.initialValues.porcentaje_cesion_comision ? formatNumber.new(modalData.datosSimulacion.initialValues.porcentaje_cesion_comision.valor) : formatNumber.new(modalData.datosSimulacion.porcentaje_cesion_comision) }%
                      </div>
                    </div>
                    
                    { modalData.datosSimulacion.initialValues &&  <>
                      <p className="card-verify__subtitle">Datos Ajustados</p>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        Pensión: 
                      </div>
                      <div className={`card-verify__data`}>
                        { modalData.datosSimulacion && modalData.datosSimulacion.pension ? modalData.datosSimulacion.moneda.simbolo + formatNumber.new(modalData.datosSimulacion.pension) : '--' }
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        Tasa de venta: 
                      </div>
                      <div className={`card-verify__data`}>
                        {modalData.datosSimulacion && modalData.datosSimulacion.tasa ? modalData.datosSimulacion.tasa : '--' }%
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        TIR: 
                      </div>
                      <div className={`card-verify__data`}>
                        {modalData.datosSimulacion && modalData.datosSimulacion.tir_actual ? modalData.datosSimulacion.tir_actual : '--' }%
                      </div>
                    </div>
                    </>}
                  </div>

                { modalData.estado !== "vencida" && <>
                  <div className="vasForm__form__input-container-select">
                  <label>Ajuste de TIR</label>
                  <InputNumber
                    nameVal="tir_objetivo"
                    setValue={setValue}
                    register={register}
                    thousandSeparator={','}
                    suffix={'%'}
                    allowNegative={true}
                    validatorInput={(value: any) => validateTirObjetive(value, clearError, 'tir_objetivo', modalData.datosSimulacion.initialValues ? modalData.datosSimulacion.initialValues.tir_actual : modalData.datosSimulacion.tir_actual)}
                    init={0}
                  />
                  <ErrorCustom errors={errors} name="tir_objetivo" />
                </div>


                <div className="vasForm__form__input-container-select">
                  <label>% Cesión de comisión (0-100)</label>
                  <InputNumber
                    nameVal="cesion_comision"
                    setValue={setValue}
                    register={register}
                    suffix={'%'}
                    validatorInput={(value: any) => validateCesionComision(value, clearError, 'cesion_comision')}
                    init={0}
                  />
                  <ErrorCustom errors={errors} name="cesion_comision" />
                </div>
                </>}
                
                  { simulationData && <>
                    <div className="card-verify verify-approved">
        
                  <div className="card-verify__body">
                    <div className="card-verify__quote">
                      Nueva pensión:
                    </div>
                    <div className={`card-verify__data is-label`}>
                      {modalData.datosSimulacion.moneda.simbolo + ' ' + formatNumber.new(simulationData.response.pension)}
                    </div>
                  </div>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">
                        Nueva tasa de venta: 
                    </div>
                    <div className={`card-verify__data is-label`}>
                      {simulationData.response.tv}%
                    </div>
                  </div>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">
                      TIR ajustada:
                    </div>
                    <div className={`card-verify__data is-label`}>
                      {simulationData.response.TIR_ACTUAL}%
                    </div>
                  </div>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">
                      Cesion comisión ajustada:
                    </div>
                    <div className={`card-verify__data is-label`}>
                      {simulationData.response.PORCENTAJE_CESION_COMISION ? `${(simulationData.response.PORCENTAJE_CESION_COMISION * 100).toFixed(2)}%` : "--"}
                    </div>
                  </div>

                  </div>
                  </>}
                
                {  modalData.estado !== "vencida" && <div className="actions">
                  <Button type="submit" className="btn is-secondary actions__cancel">
                    Cotizar
                  </Button>
                </div>}
                </form>
                <div className={"card-verify verify-approved " + `${""}`}>
                  <div className="card-verify__header">
                    <IconHolder />
                    <div className="card-verify__title">DATOS DE ASESOR</div>
                  </div></div>
                  <div className="card-verify verify-approved">
                  <div className="card-verify__body">
                    <div className="card-verify__quote">
                      Asesor actual:
                    </div>
                    {modalData.asesor && <div className={`card-verify__data`}>
                        { findNameOfAssesor(modalData.asesor.email) }
                    </div>}
                  </div>
                </div>
                { validateChannel.includes(channel) && modalData.estado !== "vencida"  && <div className="clientForm__control input-field">
                  <select
                    className="browser-default"
                    id="adviserSelected"
                    name="adviserSelected"
                    onChange={() => setFormTouched(true)}
                    ref={register}
                  >
                    <option
                      selected
                      disabled
                    >
                      Seleccionar nuevo Asesor
                    </option>
                    { availableAssesorList.length && availableAssesorList.map(
                      ((el: any) => {
                        return (
                          <option value={el.email}>{ el.name + ' ' + el.lastName }</option>
                        )
                      })
                    ) }
                  </select>
                  <ErrorCustom errors={errors} name="adviserSelected" />
                </div>}
                <div className={"card-verify verify-approved " + `${""}`}>
                <div className="card-verify__header">
                  <IconHolder />
                  <div className="card-verify__title">FECHA DE SIMULACIÓN</div>
                </div></div>
                <div className="card-verify verify-approved">
                  {modalData.datosSimulacion && <div className="card-verify__body">
                    <div className="card-verify__quote">
                      Fecha de Creación:
                    </div>
                    <div className={`card-verify__data`}>
                       {moment(modalData.fechaCreacion).format("DD/MM/YYYY")}
                    </div>
                    <div className="card-verify__quote">
                      Fecha de vencimiento:
                    </div>
                    <div className={`card-verify__data`}>
                       {moment(modalData.datosSimulacion.vencimiento).format("DD/MM/YYYY")}
                    </div>
                  </div>}
                </div>
                { validateChannel.includes(channel) && modalData.estado !== "vigente" && <div className={`clientForm__control input-field`}>
                  <div
                    className={` area--${(1 % 5) % 4
                      } child`}
                  >
                    <div className={`datapicker-single ${ errorDate && "is-error"}`}>
                      <div className="datapicker-single__body">
                        <div>
                          <label className="datapicker__label">
                            Seleccione la nueva fecha de vencimiento:
                          </label>
                        </div>
                        <DateTimePicker
                          name="fecNacimiento"
                          value={selectDate}
                          format="dd-MM-yy"
                          dayPlaceholder="dd"
                          monthPlaceholder="mm"
                          yearPlaceholder="yy"
                          onChange={(e) =>
                          {
                       
                              setFormTouched(true);
                              handleDateChange(e, modalData.fechaCreacion);
                            
                            
                          }
                          }
                          calendarIcon={
                            <img src={CalendarIcon} />
                          }
                          clearIcon={null}
                        />
                      </div>
                    </div>
                  </div>
                  {errorDate && <div className="errorCustom">{errorDate}</div>}
                </div>}

                <div className="actions">

                  <Button disabled={ (formTouched && !errorDate) ? false : true  } onClick={() => executeApis()} className="actions__continue">
                    Guardar
                  </Button>
                </div>
                
            </div>
            )}
          </div>
        </div>
      </div>
      {loadingState && <Loading />}
    </div>}
    </>
  );
};

export default ModalSide;
